module.exports = __webpack_public_path__ + "static/media/iSALogoWhite.e4e38259.png";